import UppyFactory from '../../../../factory/uppy';
import PromptModal from '../../../../modal/prompt';

const DesignFacade = require('../../../../facade/design/design');
const EditorFacade = require('../../../../facade/editor/editor');
const RestrictionsFactory = require('../../../../factory/restrictions');

const BaseView = require('./abstract-type');
const ElementListView = require('./element-list/videos-view');
const template = require('./video-type.hbs');

module.exports = BaseView.extend({
  type: 'video',
  basicHide: ['video_add', 'video_replace', 'video_flags'],

  selectSpecifyFolder: function () {
    document.querySelector('#element-restrictions-source').checked = false;
    document.querySelector('#element-restrictions-folder').checked = true;
    const sourceList = this.el.querySelector('.video-replacement-options');
    const folderList = this.el.querySelector('.video-replacement-folders');
    sourceList.classList.toggle('hidden', true);
    folderList.classList.toggle('hidden', false);
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-folder'));
  },

  selectSpecifySource: function () {
    document.querySelector('#element-restrictions-source').checked = true;
    document.querySelector('#element-restrictions-folder').checked = false;
    const sourceList = this.el.querySelector('.video-replacement-options');
    const folderList = this.el.querySelector('.video-replacement-folders');
    sourceList.classList.toggle('hidden', false);
    folderList.classList.toggle('hidden', true);
    this.initAddButton();
    this.recalculateSectionHeight(document.querySelector('#element-restrictions-folder'));
  },

  toggleSectionEvent: function (event) {
    const option = event.currentTarget;
    const sectionName = option.closest('.restrictions.group').getAttribute('data-name') || 'basic';
    const name = option.getAttribute('name') || option.closest('.restrictions.group[data-field]')?.getAttribute('data-field');
    const value = this.getOptionValue($(option));

    if (option.checked && option.id === 'element-restrictions-source' && !this.sourceListView.getData().length) {
      const [videoElement] = INKIVE.Tool.getInstance().editor.canvas.getSelectedElems() || [];

      this.sourceListView.addElement({
        source: this.selection.source,
        thumbnail: videoElement?.querySelector('image')?.getAttribute('xlink:href')
      });
    }

    if (sectionName === 'basic' && name === 'video_replace') {
      const videoInput = this.el.querySelector('#element-restrictions-source');
      const videoFolder = this.el.querySelector('#element-restrictions-folder');
      const sourceList = this.el.querySelector('.video-replacement-options');
      const folderList = this.el.querySelector('.video-replacement-folders');
      this.el.querySelector('div[data-name="source"]').classList.toggle('hidden', !value);
      this.el.querySelector('div[data-name="folder"]').classList.toggle('hidden', !value);

      videoInput.classList.toggle('hidden', !value);
      videoFolder.classList.toggle('hidden', !value);

      videoInput.checked = false;
      videoFolder.checked = false;

      sourceList.classList.toggle('hidden', true);
      folderList.classList.toggle('hidden', true);
      value || this.sourceListView.removeAllElement();
      value && this.initAddButton();
      videoInput.checked && this.onSectionChange(videoInput);
    }

    if (sectionName === 'folder') {
      this.selectSpecifyFolder();
    }

    if (sectionName === 'source') {
      this.selectSpecifySource();
    }

    this.recalculateSectionHeight(option);
    BaseView.prototype.toggleSectionEvent.apply(this, arguments);
  },

  render: async function () {
    const someGroup = _(this.groups).find(function (group) {
      return group.permissions && group.permissions.template;
    });

    if (!someGroup) return;

    const basicPermissions = _.chain(someGroup.permissions.template)
      .map(function (value, index) {
        return {
          name: index,
          tag: 'tool.restrictions.template.permission.' + index
        };
      })
      .filter(function (field) {
        return this.basicHide.indexOf(field.name) < 0;
      }, this)
      .filter(function (field) {
        return field.name.match(/^video_/);
      }).value();
    const excludedRestrictions = ['video_opacity', 'video_flags'];
    this.$el.html(template({ basic: this.sortElementPermissions('video', basicPermissions).filter((p) => !excludedRestrictions.includes(p.name)) }));
    this.initSourceList();
    await this.initLibraryFolders(this.type);
    this.renderRestrictions();
    this.renderDisabled();
  },

  remove: function () {
    if (this.folderRestrictionView) {
      this.folderRestrictionView.closeApp();
    }
  },

  updateRestrictions: async function (data) {
    const ePermissions = await RestrictionsFactory.getElementPermissions();
    const permission = _(ePermissions).findWhere({
      page_number: INKIVE.Tool._current_page_number,
      element_id: this.selection.id
    });
    const restrictions = permission ? JSON.parse(permission.restrictions) : {};

    if (restrictions.source && restrictions.source.list) {
      if (!restrictions.source.list.find((data) => { return data.source === data.tempLink; })) {
        INKIVE.Tool.getInstance().editor.canvas.call('advice.show', 'source-restriction-applied');
        console.log(data);
        restrictions.source.list.push({
          source: data.tempLink,
          thumbnail: null
        });

        RestrictionsFactory.setGlobalElementRestriction(
          this.selection.id, JSON.stringify(restrictions)
        );
      }

      for (const source of restrictions.source.list) {
        !this.sourceListView.data.find((data) => { return data.source === source.source; }) &&
          this.sourceListView.addElement(source);
      }
    }

    this.recalculateSectionHeight(document.querySelector('#element-restrictions-source'));
  },

  renderDisabled: function () {
    const replaceVideoInput = this.el.querySelector('.element-restriction-options label.switch input[type="checkbox"]');
    const replaceVideoSubInput = this.el.querySelector('.element-restriction-sub-options label.switch input[type="radio"]');
    const isReplaceOn = this.getOptionValue($(replaceVideoInput));
    const isReplaceSpecifiedOn = this.getOptionValue($(replaceVideoSubInput));
    replaceVideoInput && this.el.querySelector('div[data-name="source"]').classList.toggle('hidden', !isReplaceOn);
    replaceVideoInput && this.el.querySelector('div[data-name="folder"]').classList.toggle('hidden', !isReplaceOn);
    replaceVideoInput && replaceVideoSubInput && this.el.querySelector('.replacement-options').classList.toggle('hidden', !(isReplaceOn && isReplaceSpecifiedOn));
    this.recalculateSectionHeight(replaceVideoInput);
  },

  getOptionValue: function ($option) {
    if ($option.is('.element-list')) return this.sourceListView.getData();
    return BaseView.prototype.getOptionValue.apply(this, arguments);
  },

  _renderRestrictions: function (restrictions, sectionName) {
    BaseView.prototype._renderRestrictions.apply(this, arguments);

    if (sectionName === 'source' && restrictions[sectionName] && restrictions[sectionName].list) {
      _(restrictions[sectionName].list).each(this.sourceListView.addElement);
      setTimeout(() => this.selectSpecifySource(), 150);
    }

    if (sectionName === 'folder' && restrictions.source && restrictions.source.library_folder) {
      setTimeout(() => this.selectSpecifyFolder(), 150);
    }
  },

  initSourceList: function () {
    this.sourceListView && this.sourceListView.remove();
    this.sourceListView = new ElementListView({
      el: this.$el.find('.restrictions.group[data-name="source"] li'),
      type: 'video'
    });

    this.sourceListView.on('change', (data, type) => {
      const $input = this.sourceListView.$el.find('input');
      this.persistOptionRestriction($input);

      if (type === 'removed') this.initAddButton();
    });

    this.sourceListView.on('apply', function (data) {
      DesignFacade.set(data);
    });
  },

  initAddButton: function () {
    const addButton = this.el.querySelector('.replacement-options ul.options li .thumbnails-wrapper .add-new');

    const opts = {
      restrictions: {
        allowedFileTypes: ['.mp4', '.mov']
      },
      onFileUploaded: this.updateRestrictions.bind(this),
      onUppyInitialized: this.appendYoutubeButton
    };

    this.uppyFactory = new UppyFactory({
      id: 'uppy-library-videos',
      button: addButton,
      loadtype: 'videos',
      restrictions: opts.restrictions,
      onFileUploaded: opts.onFileUploaded,
      onUppyInitialized: opts.onUppyInitialized.bind(this)
    });

    this.uppyFactory.initUppyManager().then(() => {
      opts.onUppyInitialized && this.uppyFactory.uppy && this.uppyFactory.uppy.on('dashboard:modal-open', () => {
        opts.onUppyInitialized.call(this);
      });
      EditorFacade.trigger('videos-library-upload-button-appended', this.uppyFactory);
    });
  },

  appendYoutubeButton: function () {
    const uppyModal = this.uppyFactory.getDashboard().el;

    if (uppyModal.querySelector('.uppy-youtube-button')) {
      return;
    }

    const div = document.createElement('div');
    const button = document.createElement('button');
    button.innerHTML = '<svg><use xlink:href="#youtube"></use></svg><div class="uppy-DashboardTab-name">' +
      INKIVE.TranslateHelper.translate('tool.videos.youtube') +
      '</div>';
    button.onclick = () => {
      this.uppyFactory.closeUppyModal();
      this.displayAddYoutubeVideoModal();
    };
    button.setAttribute('class', 'uppy-u-reset uppy-c-btn uppy-DashboardTab-btn');
    div.classList.add('uppy-DashboardTab');
    div.classList.add('uppy-youtube-button');
    div.append(button);
    uppyModal.querySelector('span[role=presentation]').append(div);
  },

  displayAddYoutubeVideoModal: function () {
    this.prompt = new PromptModal({
      label: INKIVE.TranslateHelper.translate('modal.prompt.add_video')
    });

    const getYoutubeId = (url) => {
      const regex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/;
      const result = regex.exec(url);

      return result && result[1];
    };

    this.modal = INKIVE.Modal.modalWindow(this.prompt.getFormHtml(), {
      width: 400,
      headerIcon: 'fa fa-film',
      headerTitle: 'tool.customize.add_video',
      buttons: [{
        title: 'modal.buttons.add_video',
        onClick: () => {
          this.updateRestrictions({ source: getYoutubeId(this.prompt.getValue()) });
          this.modal.close();
          // this.addVideoToLibrary({ source: getYoutubeId(this.prompt.getValue()) }, _callback);
        }
      }]
    });
  },

  addVideoToLibrary: function (data, _callback) {
    const libraryInstance = Object.values(this.libraryInstances)[0];

    libraryInstance && libraryInstance.post('videos', {
      type: 'Video',
      data: {
        file: data.tempLink,
        name: data.name,
        source: data.source
      }
    });
  }
});
